import { OMNICHANNEL_STATUS } from "../components/dashboard/dashboardAnalytics/constant";
import { CAMPAIGN_STATUS } from "../components/dashboard/whatsappCampaign/campaignConstant";

export const primaryColor = "#6A097D";
export const secondaryColor = "#F7E9FF"
export const tertiaryColor = "#FBF4FF"
export const blackColor = "#000000"
export const whiteColor = "#ffffff"
export const redColor = "#ff0000"
export const imgSrcSideNavigationPanelIcon = "#4C4A4D";
export const greyColor = "#7A7A7A";
export const lightGreyColor = "#737373"
export const darkGreyPrimarySwitchBgColor = "#39393D"
export const coloredImgSrcSideNavigationPanelIcon = "#000000";
export const blueColor = "#2563EB";
export const smartAssistRequestParamsTableBgColor = "#F4F4F4";
export const errorColor = "#D11B1B";

export const successLightColor = "#ECFDF5";
export const failureLightColor = "#FEF2F2";
export const warningLightColor = "#FFFBEB";

export const failureBorderColor = "#ffd7d7";

export const deleteIconColor = "#FF0000"

export const readMessageStatusIconColor = "#0eabec";
export const deliveredMessageStatusIconColor = "#6c757d";
export const failedMessageStatusIconColor = "#FF3B30";

export const archiveBtnBgColor = "#FF9800";
export const unArchiveBtnBgColor = "#4CAF50";

export const dashboardAnalyticsNewUsersColor = "#1976d2";

export const MANUAL_OVERRIDE_BTN_TEXT_COLORS = {
    LEAVE: redColor,
    TAKEOVER: "#0C836F",
    JOIN: "#01BA5D",
    SWITCH_TO_AI: "#0C836F"
};

export const CAMPAIGN_STATUS_COLORS = {
    [CAMPAIGN_STATUS["DRAFT"]]: {
        TEXT_COLOR: "rgba(42, 165, 226, 1)",
        BG_COLOR: "rgba(42, 165, 226, 0.1)",
        ANALYTICS_COLOR: "#F7E9FF"
    },
    [CAMPAIGN_STATUS["COMPLETED"]]: {
        TEXT_COLOR: "rgba(15, 185, 21, 1)",
        BG_COLOR: "rgba(15, 185, 21, 0.1)",
        ANALYTICS_COLOR: "#344BFD"
    },
    [CAMPAIGN_STATUS["SCHEDULED"]]: {
        TEXT_COLOR: "#14B8A6",
        BG_COLOR: "#E6F7F4",
        ANALYTICS_COLOR: "#14B8A6"
    },
    [CAMPAIGN_STATUS["PAUSED"]]: {
        TEXT_COLOR: "#FACC15",
        BG_COLOR: "#FFFAE5",
        ANALYTICS_COLOR: "#FACC15"
    },
    [CAMPAIGN_STATUS["ARCHIVED"]]: {
        TEXT_COLOR: " #64748B",
        BG_COLOR: "#F1F5F9",
        ANALYTICS_COLOR: "#64748B"
    },
    [CAMPAIGN_STATUS["IN_PROGRESS"]]: {
        TEXT_COLOR: "#F97316",
        BG_COLOR: "#FFF1E6",
        ANALYTICS_COLOR: "#F97316"
    },
    [CAMPAIGN_STATUS["SENT"]]: {
        TEXT_COLOR: "#25D366",
        BG_COLOR: "#25D366",
        ANALYTICS_COLOR: "#25D366"
    },
    [CAMPAIGN_STATUS["PENDING"]]: {
        TEXT_COLOR: "#D9B903",
        BG_COLOR: "#D9B903",
        ANALYTICS_COLOR: "#D9B903"
    },
    [CAMPAIGN_STATUS["FAILED"]]: {
        TEXT_COLOR: "#D90303",
        BG_COLOR: "#D90303",
        ANALYTICS_COLOR: "#D90303",
    },
    [CAMPAIGN_STATUS["DID_NOT_SEND"]]: {
        TEXT_COLOR: "#40BBFF",
        BG_COLOR: "#40BBFF",
        ANALYTICS_COLOR: "#40BBFF"
    },
    DEFAULT: {
        TEXT_COLOR: "rgba(226, 162, 42, 1)",
        BG_COLOR: "rgba(226, 162, 42, 0.1)",
        ANALYTICS_COLOR: "#9930BC",
    }
}

export const OMNICHANNEL_STATUS_COLORS = {
  [OMNICHANNEL_STATUS["WHATSAPP"]]: {
    TEXT_COLOR: "#16A34A",
    BG_COLOR: "rgba(22, 163, 74, 0.1)",
    ANALYTICS_COLOR: "#16A34A"
  },

  [OMNICHANNEL_STATUS["INSTAGRAM"]]: {
    TEXT_COLOR: "#DB2777",
    
    BG_COLOR: "rgba(219, 39, 119, 0.1)",
    ANALYTICS_COLOR: "#DB2777"
  },

  [OMNICHANNEL_STATUS["MESSENGER"]]: {
    TEXT_COLOR: "#4338CA",
    BG_COLOR: "rgba(67, 56, 202, 0.1)",
    ANALYTICS_COLOR: "#4338CA"
  },

  [OMNICHANNEL_STATUS["WEBSITE"]]: {
    TEXT_COLOR: "#6A097D",
    BG_COLOR: "#EBD4F7",
    ANALYTICS_COLOR: "#EBD4F7"
  },

  [OMNICHANNEL_STATUS["CHRONOXAIWEBAPP"]]: {
    TEXT_COLOR: "#6A0D91",
    BG_COLOR: "rgba(106, 13, 145, 0.1)",
    ANALYTICS_COLOR: "#6A0D91"
  },

  [OMNICHANNEL_STATUS["WEB WIDGET"]]: {
    TEXT_COLOR: "#6B7280",
    BG_COLOR: "rgba(107, 114, 128, 0.1)",
    ANALYTICS_COLOR: "#6B7280"
  },

  DEFAULT: {
    TEXT_COLOR: "#94A3B8",
    BG_COLOR: "rgba(148, 163, 184, 0.1)",
    ANALYTICS_COLOR: "#94A3B8"
  }
};

// export const OMNICHANNEL_STATUS_COLORS = {
//     [OMNICHANNEL_STATUS["WHATSAPP"]]: {
//       TEXT_COLOR: "#25D366",
//       BG_COLOR: "rgba(37, 211, 102, 0.1)",
//       ANALYTICS_COLOR: "#25D366"
//     },
  
//     [OMNICHANNEL_STATUS["INSTAGRAM"]]: {
//       TEXT_COLOR: "#E4405F",
//       BG_COLOR: "rgba(228, 64, 95, 0.1)",
//       ANALYTICS_COLOR: "#C13584"
//     },
  
//     [OMNICHANNEL_STATUS["MESSENGER"]]: {
//       TEXT_COLOR: "#0084FF",
//       BG_COLOR: "rgba(0, 132, 255, 0.1)",
//       ANALYTICS_COLOR: "#0084FF"
//     },
  
//     [OMNICHANNEL_STATUS["WEB WIDGET"]]: {
//       TEXT_COLOR: "#6B7280",
//       BG_COLOR: "rgba(107, 114, 128, 0.1)",
//       ANALYTICS_COLOR: "#6B7280"
//     },

//     [OMNICHANNEL_STATUS["WEBSITE"]]: {
//       TEXT_COLOR: "#0D9488",
//       BG_COLOR: "rgba(13, 148, 136, 0.1)",
//       ANALYTICS_COLOR: "#0D9488"
//     },

//     [OMNICHANNEL_STATUS["CHRONOXAIWEBAPP"]]: {
//       TEXT_COLOR: "#6A097D",
//       BG_COLOR: "rgba(106, 9, 125, 0.1)",
//       ANALYTICS_COLOR: "#6A097D"
//     },

//     DEFAULT: {
//       TEXT_COLOR: "#94A3B8",
//       BG_COLOR: "rgba(148, 163, 184, 0.1)",
//       ANALYTICS_COLOR: "#94A3B8"
//     }
// };